const place_data_2022 =[
    {
    "Name": "Sanskriti Mishra",
    "Roll": "18BEC095",
    "Mail": "18bec095@nirmauni.ac.in",
    "Company": "Effiya Technologies",
    "Role": "Business Analyst ",
    "Website": "effiya.com",
    "Experience": "https://drive.google.com/open?id=1HHym04Ia0EGC04Zj1bPzFcMNXa4AG7jw"
    },
    {
    "Name": "Varshi Rathi",
    "Roll": "18BEC084",
    "Mail": "18bec084@nirmauni.ac.in",
    "Company": "Searce Cosourcing Services Private Limited",
    "Role": "Cloud Consultant ",
    "Website": "https://www.searce.com/",
    "Experience": "https://drive.google.com/open?id=1GCKpp5rYBTYbgVKHvvvu8z9gTxC9gdKC"
    },
    {
    "Name": "Divyansh Rai",
    "Roll": "18BEC027",
    "Mail": "18bec027@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Engineer",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1NU-Wek9cccMUzQpSM4478k2Y1sBdMz25"
    },
    {
    "Name": "Nair Anoopkumar Anilkumar",
    "Roll": "18BEC060",
    "Mail": "18bec060@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Asic Engineer",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=15lhfKUwzLeYVV7ktSQPug80OctsbdjPE"
    },
    {
    "Name": "Tanmay Jain",
    "Roll": "18BEC114",
    "Mail": "18bec114@nirmauni.ac.in",
    "Company": "Zs Associates India Pvt. Ltd.",
    "Role": "Business Technology Solution Associate (Btsa)",
    "Website": "https://www.zs.com/",
    "Experience": "https://drive.google.com/open?id=1VdR4Sh0jQgxRvEGEmd8vLC4UxOPJQWNe"
    },
    {
    "Name": "Devesh Laxminarayan Asawa",
    "Roll": "18BEC025",
    "Mail": "18bec025@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Engineer (Grade-A)",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1wZR4PFNH-5uWd6yn2jOHgkzxkkQuQmu7"
    },
    {
    "Name": "Sarthak Farkya",
    "Roll": "18BEC096",
    "Mail": "18bec096@nirmauni.ac.in",
    "Company": "Loginext Solutions , Mumbai",
    "Role": "Software Engineer",
    "Website": "https://www.loginextsolutions.com/",
    "Experience": "https://drive.google.com/open?id=1RXPansRODeWPGlIQvkVN-2zvoXKdJ3mh"
    },
    {
    "Name": "Mihir Soni",
    "Roll": "18BEC109",
    "Mail": "18bec109@nirmauni.ac.in",
    "Company": "Effiya Technologies",
    "Role": "Analyst",
    "Website": "www.effiya.com",
    "Experience": "https://drive.google.com/open?id=1OuNOH-BDVdgYm3QjWJ_FN6T2elCXdRp8"
    },
    {
    "Name": "Atish Jain",
    "Roll": "18BEC010",
    "Mail": "18bec010@nirmauni.ac.in",
    "Company": "Oracle-Gbu",
    "Role": "Associate Software Engineer/Associate Application Developer ",
    "Website": "https://www.oracle.com/",
    "Experience": "https://drive.google.com/open?id=1bXaVVbejC3Sl0y7KDNLSEBOnUyiP6O9w"
    },
    {
    "Name": "Gaurav Nanera",
    "Roll": "18BEC063",
    "Mail": "18bec063@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Asic Engineer",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1nvMH8gD748DQEOmm6q8VEGMB5jvcAyFe"
    },
    {
    "Name": "Aftaab Alam M Siddiqui",
    "Roll": "18BEC004",
    "Mail": "18bec004@nirmauni.ac.in",
    "Company": "Tcs-Digital",
    "Role": "Systems Engineer",
    "Website": "https://www.tcs.com/",
    "Experience": "https://drive.google.com/open?id=1XDVFvL1LNw1RUaDs9ZiTDfA32U6UM8mu"
    },
    {
    "Name": "Mitali pitliya ",
    "Roll": "18BEC058",
    "Mail": "18bec058@nirmauni.ac.in",
    "Company": "Deloitte India",
    "Role": "Risk Assurance Analyst ",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Experience": "https://drive.google.com/open?id=1nqV1wA9QozbvWlnpdZ2x0QZuPoZ95b9n"
    },
    {
    "Name": "Mayank Ray",
    "Roll": "18bec054",
    "Mail": "18bec054@nirmauni.ac.in",
    "Company": "Deloitte India",
    "Role": "18Bec054@Nirmauni.Ac.In",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Experience": "https://drive.google.com/open?id=1-Gvwz5Ia4Q7EU1LLHWwTtarPE9e44yKt/media/ubantu/New Volume/Local disk/Projects/Interact with Seniors/data EC Department/Higher Studies 2022"
    },
    {
    "Name": "Harsh Mandalaywala",
    "Roll": "18BEC051",
    "Mail": "18bec051@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Data not Available",
    "Website": "Data not Available",
    "Experience": "https://drive.google.com/open?id=1GsRUCel8lUFc62NINyjd3asRUVqtVSwj"
    },
    {
    "Name": "Hasit Pankaj Trivedi",
    "Roll": "18BEC037",
    "Mail": "18bec037@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Functional Consultant",
    "Website": "https://www.evosysglobal.com/",
    "Experience": "https://drive.google.com/open?id=1z6PGWCnObbSXpMuNWOpdIXpITZhHPs6c"
    },
    {
    "Name": "Ambika Lakhera",
    "Roll": "18BEC006",
    "Mail": "18bec006@nirmauni.ac.in",
    "Company": "Infineon",
    "Role": "18Bec006@Nirmauni.Ac.In",
    "Website": "https://www.infineon.com/",
    "Experience": "https://drive.google.com/open?id=1CwOnfltfXdCCYnWcsnV5VjRErk88jSsN"
    },
    {
    "Name": "Ambika Lakhera",
    "Roll": "18BEC006",
    "Mail": "18bec006@nirmauni.ac.in",
    "Company": "Tcs-Digital",
    "Role": "18Bec006@Nirmauni.Ac.In",
    "Website": "https://www.tcs.com/",
    "Experience": "https://drive.google.com/open?id=1jgcMjFRRUHjjyQJY32ukmFgLtaVC4OIw"
    },
    {
    "Name": "Bhanvadia Nandan Kirankumar",
    "Roll": "18BEC062",
    "Mail": "18bec062@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Asic Engineer",
    "Website": "www.einfochips.com",
    "Experience": "https://drive.google.com/open?id=1IGmEmVAU0lBaIEscO6dqDZ0nlxzvfn5N"
    },
    {
    "Name": "Sanika Mandar Joshi",
    "Roll": "18BEC046",
    "Mail": "18bec046@nirmauni.ac.in",
    "Company": "Zs Associates India Pvt. Ltd.",
    "Role": "Business Operations Associate (Boa)",
    "Website": "https://www.zs.com/",
    "Experience": "https://drive.google.com/open?id=1Aooq-vRb55ecLVQyXjqS3MrjM5oD74FP"
    },
    {
    "Name": "Ritik Garg",
    "Roll": "18BEC089",
    "Mail": "18bec089@nirmauni.ac.in",
    "Company": "Infineon",
    "Role": "Tbd",
    "Website": "https://www.infineon.com/",
    "Experience": "https://drive.google.com/open?id=1bZnYIlvxgELLbRkWn4SX1X-f_wZcWYUE"
    },
    {
    "Name": "Suyash Malik",
    "Roll": "18BEC112",
    "Mail": "18bec112@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Oracle Functional Consultant (Hcm)",
    "Website": "https://www.evosysglobal.com/",
    "Experience": "https://drive.google.com/open?id=1D3s754mKbUp4cFBt6-LMxndX559YcUXC"
    },
    {
    "Name": "Raghav Lakhotia",
    "Roll": "18BEC082",
    "Mail": "18bec082@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Functional Consultant",
    "Website": "https://www.evosysglobal.com/",
    "Experience": "https://drive.google.com/open?id=1xMDwiSdLzzefwncbyEdVNAo0Ri_sqM43"
    },
    {
    "Name": "Rishika Patwa",
    "Roll": "18BEC087",
    "Mail": "18bec087@nirmauni.ac.in",
    "Company": "Zs Associates India Pvt. Ltd.",
    "Role": "Boa",
    "Website": "https://www.zs.com/",
    "Experience": "https://drive.google.com/open?id=14FFy-6mFuRvSbCJs27atc3gLQxGvqf7n"
    },
    {
    "Name": "Pragya Jhala",
    "Roll": "18BEC043",
    "Mail": "18bec043@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Functional Consultant",
    "Website": "https://www.evosysglobal.com/",
    "Experience": "https://drive.google.com/open?id=1ZjRIf79pv1s7xdjpDY4LwM6RtzMJcASC"
    },
    {
    "Name": "Vandit Prajapati",
    "Roll": "18BEC075",
    "Mail": "18bec075@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Pes",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1Xlx6hIJfizt7nDcGQuDSAbJEmW04PmOW"
    },
    {
    "Name": "Amita Mohta",
    "Roll": "18BEC007",
    "Mail": "18bec007@nirmauni.ac.in",
    "Company": "Infineon",
    "Role": "Design Engineer - Verification ",
    "Website": "https://www.infineon.com/",
    "Experience": "https://drive.google.com/open?id=1ja6wp55-x4BJdCGvjryg1LQbX1_6TiD5"
    },
    {
    "Name": "Janyae Girish Lahori",
    "Roll": "18BEC049",
    "Mail": "18bec049@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Asic Engineer",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1RxeOiiy7K4PYZI6NjGMSoD-ImyLCWLEu"
    },
    {
    "Name": "Janyae Girish Lahori",
    "Roll": "18BEC049",
    "Mail": "18bec049@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Asic Engineer",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1ewnKfoapKa6TgJVrWOGNVk9U06hUBMMH"
    },
    {
    "Name": "Virag C. Shah",
    "Roll": "18BEC123",
    "Mail": "18bec123@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Pes_Hardware",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1vZDNEdV55vFEPX8OUF7kmQonAenTcser"
    },
    {
    "Name": "Shivam Kapildev Pandey",
    "Roll": "18BEC101",
    "Mail": "18bec101@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Asic Engineer",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1I2_ld4J6eqhwt7jD-Cc6zVnb1H1al0iu"
    },
    {
    "Name": "Yashasvi Girishbhai Shah",
    "Roll": "18BEC100",
    "Mail": "18bec100@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Asic Engineer",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1RIXX4h886uSdvZIBeR2EuSklHjSwX75c"
    },
  
    {
    "Name": "Soham Rajeshkumar Jani",
    "Roll": "18BEC041",
    "Mail": "18bec041@nirmauni.ac.in",
    "Company": "Quinbay",
    "Role": "Software Developer",
    "Website": "www.quinbay.com",
    "Experience": "https://drive.google.com/open?id=11rO3HMeqLu-uvHGoOyYf4Kgjx25NqOaL"
    },
    {
    "Name": "Kshitij Singh",
    "Roll": "18BEC108",
    "Mail": "18bec108@nirmauni.ac.in",
    "Company": "Tcs-Digital",
    "Role": "System Engineer",
    "Website": "https://nextstep.tcs.com/campus/#/",
    "Experience": "https://drive.google.com/open?id=1wQvaeGgpoXSdmNJeUNbXKfhllxcAyKO_"
    },
  
    {
    "Name": "Manan Jain",
    "Roll": "18BEC050",
    "Mail": "18bec050@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Engineer (Grade - A)",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=17STSvWGypFaov7uav0IMovN2owwuqrtT"
    },
    {
    "Name": "Chunara Monish Siraj",
    "Roll": "18BEC021",
    "Mail": "18bec021@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Trainee Engineer (Pes-Product Engineering Services)",
    "Website": "www.einfochips.com",
    "Experience": "https://drive.google.com/open?id=19cgAMHfk6V5UUdHhlbJEly61THXWN7Er"
    },
    {
    "Name": "Manan Jain",
    "Roll": "18BEC050",
    "Mail": "18bec050@nirmauni.ac.in",
    "Company": "Infineon",
    "Role": "Tbd (Application Engineer)",
    "Website": "https://www.infineon.com/",
    "Experience": "https://drive.google.com/open?id=19owH0w3llfeZ3lTFoDqWsmzm-3CytJsT"
    },
    {
    "Name": "Deep Bhavsar",
    "Roll": "18BEC014",
    "Mail": "18bec014@nirmauni.ac.in",
    "Company": "Deloitte India",
    "Role": "Risk Assurance Analyst",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Experience": "https://drive.google.com/open?id=1HATXhfKIp-XGEhgHk7fHlXL98lFBISiL"
    },
    {
    "Name": "Het Ratilal Kanzariya",
    "Roll": "18BEC047",
    "Mail": "18bec047@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Product Engineering Services",
    "Website": "http://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1B-WbwwmXS0or3JlWdrtTA83Oni4gonZi"
    },
    {
    "Name": "Kshitij Singh",
    "Roll": "18BEC108",
    "Mail": "18bec108@nirmauni.ac.in",
    "Company": "Quinbay",
    "Role": "Data not Available",
    "Website": "https://www.quinbay.com/",
    "Experience": "https://drive.google.com/open?id=1z9Ys2tCZ8Zw6-eIUk24rphhZdJ-_q4rD"
    },
    {
    "Name": "Taman Sachanandani",
    "Roll": "18BEC091",
    "Mail": "18bec091@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Hcm Functional Consulting",
    "Website": "https://www.evosysglobal.com/",
    "Experience": "https://drive.google.com/open?id=19q0zetO_EmRcdI65sDqz2Yed7IOvdDge"
    },
    {
    "Name": "Devesh Laxminarayan Asawa",
    "Roll": "18bec025",
    "Mail": "18bec025@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Pes Engineer",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1j9yy58HxHpUad-yDFJZpG_wntjNPlyAM"
    },
    {
    "Name": "Yash Talesara",
    "Roll": "18BEC126",
    "Mail": "18bec126@nirmauni.ac.in",
    "Company": "I Got The Offer Through An Off-Campus Opportunity",
    "Role": "Daa",
    "Website": "zs.com",
    "Experience": "https://drive.google.com/open?id=13Ei_MonJ95IH14V_tg2RKTX-TRcFrifb"
    },
    {
    "Name": "Mihir Gandhi",
    "Roll": "19BEC502",
    "Mail": "19bec502@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Asic Engineer ",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1nhkJf5XSQsUmQht2k30E-SO3h4Vg92s8"
    },
    {
    "Name": "Hard Rokad",
    "Roll": "18BEC090",
    "Mail": "18bec090@nirmauni.ac.in",
    "Company": "Campus Beats - Zs Case Challenge Fy'2021-22 | Ppi Offers",
    "Role": "Boa (Business Operations Associate)",
    "Website": " https://www.zs.com/",
    "Experience": "https://drive.google.com/open?id=1536OyEc_33MZ3u3zOjvQFECDIsNtJLwJ"
    },
    {
    "Name": "Pranit Soni",
    "Roll": "18BEC078",
    "Mail": "18bec078@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Hcm-Functional Consultant",
    "Website": "https://www.evosysglobal.com/",
    "Experience": "https://drive.google.com/open?id=1fqtSUizEYY6BZ3MEw-JZ0kf8c6u8Znga"
    },
    {
    "Name": "Masharu Yesha Tushar",
    "Roll": "18BEC053",
    "Mail": "18bec053@nirmauni.ac.in",
    "Company": "Zs Associates India Pvt. Ltd.",
    "Role": "Business Technology Solutions Associate ",
    "Website": "https://www.zs.com/",
    "Experience": "https://drive.google.com/open?id=1W2YklC9K_MiUyDHoPaEi69aEdtLxBWfs"
    },
    {
    "Name": "Shubham Soni",
    "Roll": "18BEC110",
    "Mail": "18bec110@nirmauni.ac.in",
    "Company": "Cognizant Genc Elevate",
    "Role": "Advanced Java Developer - Programmer Analyst",
    "Website": "www.cognizant.com",
    "Experience": "https://drive.google.com/open?id=1hja8IruS-gSrHv3soUmWuJzD6JZcp58I"
    },
    {
    "Name": "Sakshi Agarwal",
    "Roll": "18BEC092",
    "Mail": "18bec092@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Oracle Functional Consultant",
    "Website": "https://www.evosysglobal.com",
    "Experience": "https://drive.google.com/open?id=1WPAOLL0xhihU88qMQ0SON79Ph9roxP1_"
    },
    {
    "Name": "Shivam Agrawal",
    "Roll": "18BEC129",
    "Mail": "18bec129@nirmauni.ac.in",
    "Company": "Tcs-Digital",
    "Role": "System Engineer",
    "Website": "https://www.tcs.com/",
    "Experience": "https://drive.google.com/open?id=16YHdVxKM32J8j27rGLYeIUsrH2CcULUR"
    },
    {
    "Name": "Divyansh Rai",
    "Roll": "18BEC027",
    "Mail": "18bec027@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Engineer (Grade - A)",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1pvwXkdWfrMLLwlUBweozgRUx70L2Uha6"
    },
    {
    "Name": "Pranav Singh",
    "Roll": "18BEC077",
    "Mail": "18bec077@nirmauni.ac.in",
    "Company": "Deloitte India",
    "Role": "Risk Assurance Analyst",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Experience": "https://drive.google.com/open?id=1ecJtakWZWFRluVOTzhyG7PVkP_Xb3-IG"
    },
    {
    "Name": "Nairit Joshi",
    "Roll": "18BEC061",
    "Mail": "18bec061@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Hcm Functional Consultant",
    "Website": "https://www.evosysglobal.com/",
    "Experience": "https://drive.google.com/open?id=16yeWmL_IuxcqO6t4wUaEDg9Zu6ZNO9Xr"
    },
    {
    "Name": "Rhea Sansowa",
    "Roll": "18BEC086",
    "Mail": "18bec086@nirmauni.ac.in",
    "Company": "Zs Associates India Pvt. Ltd.",
    "Role": "Btsa",
    "Website": "https://www.zs.com/",
    "Experience": "https://drive.google.com/open?id=1vq-_AxORzU8AS618djY9FuAFaMa9Nl2q"
    },
    {
    "Name": "Anuj Shukla",
    "Roll": "18bec104",
    "Mail": "18bec104@nirmauni.ac.in",
    "Company": "Zs Associates India Pvt. Ltd.",
    "Role": "Business Operation Associate",
    "Website": "https://www.zs.com/",
    "Experience": "https://drive.google.com/open?id=1HPnkJUsY1W0ZC77o0CWPG8HPibtGIf1Q"
    },
    {
    "Name": "Samaksh Mittal",
    "Roll": "18BEC093",
    "Mail": "18bec093@nirmauni.ac.in",
    "Company": "Toddle",
    "Role": "Frontend Developer (Performance Based Selection)",
    "Website": "https://www.toddleapp.com/",
    "Experience": "https://drive.google.com/open?id=1zHjJvbtMBTmYmIcoJ1gRJqYTZ4c8qNl8"
    },
    {
    "Name": "Thakkar Anisha Arvindbhai",
    "Roll": "18BEC116",
    "Mail": "18bec116@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Engineer In The Pes Business Unit",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1Ws8Y3FYtkGr8kQOG5aAcS-QeAVTnMf1m"
    },
    {
    "Name": "Shivam Shukla",
    "Roll": "18bec102",
    "Mail": "18bec102@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Erp ",
    "Website": "https://www.evosysglobal.com/",
    "Experience": "https://drive.google.com/open?id=1VXDqHSD8G5ox6niGoO-P3sBZaptVvJF9"
    },
    {
    "Name": "Mihir Gandhi",
    "Roll": "19BEC502",
    "Mail": "19bec502@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Hcm Oracle Functional Consultant",
    "Website": "https://www.evosysglobal.com/",
    "Experience": "https://drive.google.com/open?id=19f7Y5LrhZqxzKFZLWx40ibfZQdC2uoF6"
    },
    {
    "Name": "Yash Jain",
    "Roll": "18BEC127",
    "Mail": "18bec127@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Software ,Product Engineering Services",
    "Website": "www.einfochips.com",
    "Experience": "https://drive.google.com/open?id=1j5apjOu-xt9Nvh0I7nDuviRdTvkRCyRY"
    },
    {
    "Name": "Bhavin Kanubhai Patel",
    "Roll": "18BEC071",
    "Mail": "18bec071@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Pes Software",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1h8qIt8YZQuip1xs32uHsmEXfFByAqFpk"
    },
    {
    "Name": "Ritik Garg",
    "Roll": "18BEC089",
    "Mail": "18bec089@nirmauni.ac.in",
    "Company": "Infineon",
    "Role": "Tbd",
    "Website": "https://www.infineon.com/",
    "Experience": "https://drive.google.com/open?id=1xtTexMNGqyyG2IakXL8Z5p_U4eosBaDA"
    },
    {
    "Name": "Nitin Agarwal",
    "Roll": "18BEC066",
    "Mail": "18bec066@nirmauni.ac.in",
    "Company": "Data not Available",
    "Role": "Pes Engineer",
    "Website": "https://www.einfochips.com",
    "Experience": "https://drive.google.com/open?id=1gdw7llmKxLsbLL9RlkhgKZLmW-chBh-4"
    },
    {
    "Name": "Chinmaya Mishra",
    "Roll": "18BEC019",
    "Mail": "18bec019@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Professional Trainee",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1w4kY_ZPJ1lRJwGp94iVx18p5Gk7YFLhI"
    },
    {
    "Name": "Kaushik Thumar",
    "Roll": "18bec117",
    "Mail": "18bec117@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Product Engineering Services (Pes)",
    "Website": "www.einfochips.com",
    "Experience": "https://drive.google.com/open?id=1i8Be2ACBecvoZL8OfEZrFZf9fvUo3WH_"
    },
    {
    "Name": "Harsh Mandalaywala",
    "Roll": "18BEC051",
    "Mail": "18bec051@nirmauni.ac.in",
    "Company": "Delloite Csad Analyst",
    "Role": "Customer Strategy & Applied Design (Csad) Analyst",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Experience": "https://drive.google.com/open?id=1HabteqauluD4XAqmTFOgjagG1HYFZ2ra"
    },
    {
    "Name": "Shwet Upadhyay",
    "Roll": "18BEC106",
    "Mail": "18bec106@nirmauni.ac.in",
    "Company": "Optum",
    "Role": "Software Engineer",
    "Website": "https://www.optum.in/",
    "Experience": "https://drive.google.com/open?id=1QsRSTwIVxFmQmBrib6pjaP9-cJIvOvpt"
    },
    {
    "Name": "Vivek Vagheswari",
    "Roll": "18BEC120",
    "Mail": "18bec120@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Pes",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1SshbKfpbDHsXF2V5RjLiBLCfuWAzxxvs"
    },
    {
    "Name": "Nairit Joshi",
    "Roll": "18BEC061",
    "Mail": "18bec061@nirmauni.ac.in",
    "Company": "Delloite Csad Analyst",
    "Role": "Csad Analyst",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Experience": "https://drive.google.com/open?id=1AFPV87BL07XBjno-gJhc7iVwjHB63UH-"
    },
    {
    "Name": "Aashvi Gajjar",
    "Roll": "18BEC002",
    "Mail": "18bec002@nirmauni.ac.in",
    "Company": "Delloite Csad Analyst",
    "Role": "Customer Strategy And Applied Design Analyst",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Experience": "https://drive.google.com/open?id=1yOsemkyB0_pwBXS2iG10oeB_ZHk3wiY3"
    },
    {
    "Name": "Dhawnil Khandelwal",
    "Roll": "18BEC026",
    "Mail": "18bec026@nirmauni.ac.in",
    "Company": "Deloitte India",
    "Role": "Cs&Ad Analyst",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Experience": "https://drive.google.com/open?id=15GMXwkr4tx-gxwRSc0dvPW0YYxs2Esu9"
    },
    {
    "Name": "Ashu Mittal",
    "Roll": "18BEC009",
    "Mail": "18bec009@nirmauni.ac.in",
    "Company": "Publicis Sapient",
    "Role": "Junior Associate Technology",
    "Website": "https://www.publicissapient.com/",
    "Experience": "https://drive.google.com/open?id=1mlMVK0GUERQscdsCEt5AGCUA4xOq6KSv"
    },
    {
    "Name": "Devesh Laxminarayan Asawa",
    "Roll": "18BEC025",
    "Mail": "18bec025@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Pes Engineer",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1g2n_M2L0cHGSJfU8YroW6J7KAqL8VZjV"
    },
    {
    "Name": "Eshan Saraogi",
    "Roll": "18bec029",
    "Mail": "18bec029@nirmauni.ac.in",
    "Company": "Data not Available",
    "Role": "Programmer Analyst",
    "Website": "https://www.cognizant.com/in/en",
    "Experience": "https://drive.google.com/open?id=1h2f_5sbjAXqvgmiNNTS3bEUeTzdbG2vw"
    },
    {
    "Name": "Ashu Mittal",
    "Roll": "18BEC009",
    "Mail": "18bec009@nirmauni.ac.in",
    "Company": "Cognizant",
    "Role": "Genc",
    "Website": "https://www.cognizant.com/in/en",
    "Experience": "https://drive.google.com/open?id=1MkVO0cvIcuZHR0IKQ3Xe56pJ7rMNV-EM"
    },
    {
    "Name": "Gazal Gupta ",
    "Roll": "18bec033",
    "Mail": "18bec033@nirmauni.ac.in",
    "Company": "Amdocs",
    "Role": "Development/Managed Services ",
    "Website": "https://www.amdocs.com/",
    "Experience": "https://drive.google.com/open?id=1TKa7zDc-Uixv_NkKOhIUrufPFCeVJgy1"
    },
    {
    "Name": "Divyesh Ranpariya",
    "Roll": "18BEC083",
    "Mail": "18bec083@nirmauni.ac.in",
    "Company": "Nvidia",
    "Role": "Divyeshranpariya23@Gmail.Com",
    "Website": "https://www.nvidia.com/en-in/",
    "Experience": "https://drive.google.com/open?id=1O76FHIP979qhC-y0beeye3KgjUDqm9wC"
    },
    {
    "Name": "Raghav Devendra Lakhotia",
    "Roll": "18BEC082",
    "Mail": "18bec082@nirmauni.ac.in",
    "Company": "Cognizant",
    "Role": "Software Engineer",
    "Website": "https://www.cognizant.com/in/en",
    "Experience": "https://drive.google.com/open?id=1JFI3DyU5b2OqEb-3AVtLNuRqSuEmQSfo"
    },
    {
    "Name": "Raghav Devendra Lakhotia",
    "Roll": "18BEC082",
    "Mail": "18bec082@nirmauni.ac.in",
    "Company": "Evosys",
    "Role": "Associate Functional Consultant",
    "Website": "https://www.evosysglobal.com/",
    "Experience": "https://drive.google.com/open?id=1PmwWNS8q51R27-8rcWPcBbIIAye92ueG"
    },
    {
    "Name": "Aftaab Alam M Siddiqui",
    "Roll": "18bec004",
    "Mail": "18bec004@nirmauni.ac.in",
    "Company": "Cognizant",
    "Role": "Programmer Analyst Trainee",
    "Website": "https://www.cognizant.com/in/en",
    "Experience": "https://drive.google.com/open?id=1KepstpWBN80nYop1hNpi14J6_siW3a31"
    },
    {
    "Name": "Jivansu Vyas",
    "Roll": "18bec044",
    "Mail": "18bec044@nirmauni.ac.in",
    "Company": "Secure Meters",
    "Role": "Hardware Designer",
    "Website": "https://www.securemeters.com/",
    "Experience": "https://drive.google.com/open?id=1LkCQr9JkkjhS4jF69ZqlgbMcwqCGttY3"
    },
    {
    "Name": "Hasit Trivedi",
    "Roll": "18BEC037",
    "Mail": "18bec037@nirmauni.ac.in",
    "Company": "Deloitte India",
    "Role": "Cs&Ad Analyst",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Experience": "https://drive.google.com/open?id=1MNHxs5IPQmuKV5Uo7TvQWtdvSg9vTR36"
    },
    {
    "Name": "Abha Buch",
    "Roll": "18BEC003",
    "Mail": "18bec003@nirmauni.ac.in",
    "Company": "Data not Available",
    "Role": "Assistant System Engineer-Trainee In Grade Y",
    "Website": "https://nextstep.tcs.com/",
    "Experience": "https://drive.google.com/open?id=1YRKMIIg2yVU3jtAOyw4OpcVf6eCbBfO0"
    },
    {
    "Name": "Damini Rathi",
    "Roll": "18BEC023",
    "Mail": "18bec023@nirmauni.ac.in",
    "Company": "Cognizant Genc Elevate",
    "Role": "Programmer Analyst Trainee",
    "Website": "https://www.cognizant.com/in/en",
    "Experience": "https://drive.google.com/open?id=1qCPmrLnR7SellljsujJSXXzWjRJC-oeW"
    },
    {
    "Name": "Divyesh Ranpariya",
    "Roll": "18BEC083",
    "Mail": "18bec083@nirmauni.ac.in",
    "Company": "Tcs Ninja",
    "Role": "Generic (Rcs-Ninja)",
    "Website": "https://www.tcs.com/",
    "Experience": "https://drive.google.com/open?id=16BScoptLz0J0gG_IApInEg8-Q7d9200x"
    },
    {
    "Name": "Soham Jani",
    "Roll": "18BEC041",
    "Mail": "18bec041@nirmauni.ac.in",
    "Company": "Quinbay",
    "Role": "Software Developer",
    "Website": "www.quinbay.com",
    "Experience": "https://drive.google.com/open?id=1j1FlpLuNSY0QuI_T1THg0QkMW00zS97d"
    },
    {
    "Name": "Chunara Monish Siraj",
    "Roll": "18BEC021",
    "Mail": "18bec021@nirmauni.ac.in",
    "Company": "Tcs Ninja",
    "Role": "Generic Profile (Tcs Ninja)",
    "Website": "https://www.tcs.com/",
    "Experience": "https://drive.google.com/open?id=1xM2pvMIfOzAlR_B1ioXLa2aG--hiqv8l"
    },
    {
    "Name": "Vivek Vagheswari",
    "Roll": "18BEC120",
    "Mail": "18bec120@nirmauni.ac.in",
    "Company": "Tcs Ninja",
    "Role": "Intern",
    "Website": "https://dss.tcs.com/",
    "Experience": "https://drive.google.com/open?id=1c5gwmXnEgOhGlCoePaXoUp33tPDDUddG"
    },
    {
    "Name": "Maitry Mehulkumar Dumaswala",
    "Roll": "18bec028",
    "Mail": "18bec028@nirmauni.ac.in",
    "Company": "Delloite Csad Analyst",
    "Role": "18Bec028@Nirmauni.Ac.In",
    "Website": "https://www2.deloitte.com/in",
    "Experience": "https://drive.google.com/open?id=1DxA954LtCNFhZhRvAPrVL2rTX-OOmOhI"
    },
    {
    "Name": "Krutarth Parag Choksi",
    "Roll": "18BEC020",
    "Mail": "18bec020@nirmauni.ac.in",
    "Company": "Tcs Ninja",
    "Role": "Assistant System Engineer Trainee",
    "Website": "https://www.tcs.com/",
    "Experience": "https://drive.google.com/open?id=1V5G8yYBCviGRjoPtKx-8rcpJJM0UXWX1"
    },
    {
    "Name": "Samarth Garg",
    "Roll": "18bec094",
    "Mail": "18bec094@nirmauni.ac.in",
    "Company": "State Street Corporation",
    "Role": "Software Engineer",
    "Website": "https://www.statestreet.com/home.html",
    "Experience": "https://drive.google.com/open?id=1RlsK1Cjs7SODU6s52n77AFP5uXIm41Jr"
    },
    {
    "Name": "Shivam Shukla",
    "Roll": "18bec102",
    "Mail": "18bec102@nirmauni.ac.in",
    "Company": "Infor",
    "Role": "Associate Software Engineer",
    "Website": "https://www.infor.com/",
    "Experience": "https://drive.google.com/open?id=1lFpPF5vmmR__rcEDIoRx0cILKNZQhggK"
    },
    {
    "Name": "Kshitij Singh",
    "Roll": "18BEC108",
    "Mail": "18bec108@nirmauni.ac.in",
    "Company": "Optum",
    "Role": "Software Engineer ",
    "Website": "Optum.com",
    "Experience": "https://drive.google.com/open?id=1nl0dDh_p60BEON13XwuxPiIbReNg8k_n"
    },
    {
    "Name": "Akanksha Arora",
    "Roll": "18bec005",
    "Mail": "18bec005@nirmauni.ac.in",
    "Company": "Cognizant Genc Elevate",
    "Role": "Program Analyst Trainee",
    "Website": "https://careers.cognizant.com/in/en",
    "Experience": "https://drive.google.com/open?id=1mcOugXi4V-2FekiGA1rrXSrTTKGKxP5G"
    },
    {
    "Name": "Akanksha Arora",
    "Roll": "18bec005",
    "Mail": "18bec005@nirmauni.ac.in",
    "Company": "Tcs Ninja",
    "Role": "Generic Profile",
    "Website": " https://on.tcs.com/3rbqRLz",
    "Experience": "https://drive.google.com/open?id=1128l3UCNNlfvVeheALCE4zAgR8bpZeUW"
    },
    {
    "Name": "Sanjaykumar Jashvantbhai Parmar",
    "Roll": "18BEC069",
    "Mail": "18bec069@nirmauni.ac.in",
    "Company": "Optum",
    "Role": "Software Engineer",
    "Website": "https://www.optum.com/",
    "Experience": "https://drive.google.com/open?id=1y40BpwZAEsH3OKptzlaILBCpUWdMopqm"
    },
    {
    "Name": "Hardik",
    "Roll": "18BEC057",
    "Mail": "18bec057@nirmauni.ac.in",
    "Company": "Only Internship Offered",
    "Role": "Internship At Ins, Valsura",
    "Website": "https://www.indiannavy.nic.in/insvalsura/",
    "Experience": "https://drive.google.com/open?id=1g0Y5NvlUwwqCiWqTxOfSen9_jX4_fkov"
    },
    {
    "Name": "Prateek Pandya",
    "Roll": "18bec079",
    "Mail": "18bec079@nirmauni.ac.in",
    "Company": "Cognizant",
    "Role": "Programmer Analyst Trainee",
    "Website": "https://www.cognizant.com/in/en",
    "Experience": "https://drive.google.com/open?id=1K979W7UaiR1OhoHNjkbjKg9qKsqCkKRw"
    },
    {
    "Name": "Harshil Shah",
    "Roll": "18BEC035",
    "Mail": "18bec035@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Pes Engineer",
    "Website": "https://www.einfochips.com/",
    "Experience": "https://drive.google.com/open?id=1KAnruRHujkxg02gqLOmPO6uSFmQghfj1"
    },
    {
    "Name": "Yash Jha",
    "Roll": "17BEC128",
    "Mail": "17bec128@nirmauni.ac.in",
    "Company": "Deloitte India",
    "Role": "Customer Strategy And Applied Design Analyst",
    "Website": "https://www2.deloitte.com/in/en.html",
    "Experience": "https://drive.google.com/open?id=1DKlzjYGYtoly_Vn7JRKmncyM9NjWo_1Z"
    },
    {
    "Name": "Kanzariya Het Ratilal",
    "Roll": "18BEC047",
    "Mail": "18bec047@nirmauni.ac.in",
    "Company": "E-Infochips",
    "Role": "Project Trainee",
    "Website": "https://www.einfochips.com",
    "Experience": "https://drive.google.com/open?id=1IrXjgXBXlE-irqD3lU5nwK0YTKqZQ9Jf"
    },
    {
    "Name": "Vincent Abraham",
    "Roll": "18BEC122",
    "Mail": "18bec122@nirmauni.ac.in",
    "Company": "Only Internship Offered",
    "Role": "Data not Available",
    "Website": "https://oxvi.life/",
    "Experience": "https://drive.google.com/open?id=1RouQr9YnA-PFc9zW_WET4oR2dKlQRmfH"
    },
    {
    "Name": "Vardhan Batavia",
    "Roll": "18BEC013",
    "Mail": "18bec013@nirmauni.ac.in",
    "Company": "Silion Labs",
    "Role": "Application Engineer",
    "Website": "https://www.silabs.com/",
    "Experience": "https://drive.google.com/open?id=1oOrLXuBnwCszifxPvmvLr1-1Vf8bKYVS"
    },
    {
    "Name": "Parin Parikh",
    "Roll": "18BEC067",
    "Mail": "18bec067@nirmauni.ac.in",
    "Company": "I Got The Offer Through An Off-Campus Opportunity",
    "Role": "Data not Available",
    "Website": "https://www.ibm.com/in-en?lnk=m",
    "Experience": "https://drive.google.com/open?id=1hXbLyFmu4HZEVE6D_6EvoOfWPxhbJk42"
    },
    {
    "Name": "Riya Tanna",
    "Roll": "18BEC115",
    "Mail": "18bec115@nirmauni.ac.in",
    "Company": "I Got The Offer Through An Off-Campus Opportunity",
    "Role": "Data not Available",
    "Website": "https://www.ibm.com/in-en",
    "Experience": "https://drive.google.com/open?id=1P2bAWhZr7xBSIzuZ-1ZmC-hFIMlVMRCI"
    },
    {
    "Name": "Khyat Patel",
    "Roll": "18BEC048",
    "Mail": "18bec048@nirmauni.ac.in",
    "Company": "Only Internship Offered",
    "Role": "Depends On Internship Performance",
    "Website": "https://www.appliedmaterials.com/",
    "Experience": "https://drive.google.com/open?id=1QS9QX_XUIwPBvjo3WhTfyZGJh4DU0Vzq"
    },
    {
    "Name": "Bhavsar Vishwam",
    "Roll": "18BEC015",
    "Mail": "18bec015@nirmauni.ac.in",
    "Company": "Only Internship Offered",
    "Role": "Conversion Based On Performance",
    "Website": "https://www.appliedmaterials.com/",
    "Experience": "https://drive.google.com/open?id=1GvvkBwX9XdQwn-CMC-KaaIoPMZic-Wq6"
    }
]

export default place_data_2022;